var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_433_3849)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C8.01166 0 7.63859 0.01375 6.46525 0.066C5.29375 0.121 4.49625 0.30525 3.795 0.5775C3.07175 0.858 2.45759 1.23475 1.84616 1.84616C1.23475 2.45759 0.857084 3.07084 0.5775 3.795C0.30525 4.49625 0.120083 5.29375 0.066 6.46525C0.011 7.63859 0 8.01166 0 11C0 13.9883 0.01375 14.3614 0.066 15.5347C0.121 16.7054 0.30525 17.5038 0.5775 18.205C0.858 18.9274 1.23475 19.5424 1.84616 20.1539C2.45759 20.7644 3.07084 21.1429 3.795 21.4225C4.49716 21.6939 5.29466 21.8799 6.46525 21.934C7.63859 21.989 8.01166 22 11 22C13.9883 22 14.3614 21.9862 15.5347 21.934C16.7054 21.879 17.5038 21.6939 18.205 21.4225C18.9274 21.142 19.5424 20.7644 20.1539 20.1539C20.7644 19.5424 21.1429 18.9301 21.4225 18.205C21.6939 17.5038 21.8799 16.7054 21.934 15.5347C21.989 14.3614 22 13.9883 22 11C22 8.01166 21.9862 7.63859 21.934 6.46525C21.879 5.29466 21.6939 4.49534 21.4225 3.795C21.142 3.07175 20.7644 2.45759 20.1539 1.84616C19.5424 1.23475 18.9301 0.857084 18.205 0.5775C17.5038 0.30525 16.7054 0.120083 15.5347 0.066C14.3614 0.011 13.9883 0 11 0ZM16.8723 6.4487C17.6 6.4487 18.1923 5.85745 18.1923 5.1287C18.1923 4.40086 17.5991 3.8087 16.8723 3.80961C16.1444 3.80961 15.5522 4.40086 15.5522 5.1287C15.5522 5.85654 16.1434 6.4487 16.8723 6.4487ZM5.35153 11C5.35153 7.88145 7.87878 5.35145 11 5.35145C14.1185 5.35145 16.6485 7.8787 16.6485 11C16.6485 14.1185 14.1213 16.6485 11 16.6485C7.88153 16.6485 5.35153 14.1212 5.35153 11ZM11 14.6667C8.97421 14.6667 7.33337 13.0259 7.33337 11.0001C7.33337 8.97422 8.97421 7.33339 11 7.33339C13.0259 7.33339 14.6667 8.97422 14.6667 11.0001C14.6667 13.0259 13.0259 14.6667 11 14.6667Z",
    fill: "#FDF4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_433_3849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8a8fd1739e3751b1ab6285949dcde87b.svg";
export { ForwardRef as ReactComponent };